module.exports = __webpack_public_path__ + "img/chopped-vegetable-frittata.025d4d79.jpg";